import { render, staticRenderFns } from "./LoadoutCreateDialog.vue?vue&type=template&id=7130016d&scoped=true&"
import script from "./LoadoutCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./LoadoutCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130016d",
  null
  
)

export default component.exports